define('model/ServiceModel',['require','lib/model/BaseModel'],function (require) {
	
	var BaseModel = require('lib/model/BaseModel');
	
	/**
	 * Service info model
	 * 
	 * @class ServiceModel
	 */
	return BaseModel.extend({

		urlRoot: '/service/id/',

		defaults: {
			id: '',
			description: '',
			name: ''
		},

		toJSON: function (options) {
			var result = BaseModel.prototype.toJSON.apply(this, arguments);

			return _.extend(result, {
                is_recurring: (parseInt(result.is_recurring) === 1),
            	in_membership: !!(result.memberships && result.memberships.length > 0)
			});
		}
		
	});
	
});
